import {
    Container,
    Description,
    InputContainer,
    ErrorText,
    InvitationsStatusButton,
    InviteButton,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/InviteSection.styled";
import ChipsInput from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/ChipsInput/ChipsInput";
import type { IInvitation } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";
import { useInviteSection } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/utils/useInviteSection";
import { BUTTON_WIDTH } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/InviteSection/utils/consts";

interface IInviteSectionProps {
    onOpenStatusScreen: VoidFunction;
    invitationsList: IInvitation[];
    setInvitationsList: (invitations: IInvitation[]) => void;
}

const InviteSection = ({ onOpenStatusScreen, invitationsList, setInvitationsList }: IInviteSectionProps) => {
    const {
        emailChips,
        setEmailChips,
        inputRef,
        setInvalidEmails,
        invalidEmails,
        handleInviteClick,
        hasChipsError,
        isInviteLoading,
    } = useInviteSection({ invitationsList, setInvitationsList });

    const i18n = i18nFilter();

    return (
        <Container>
            <Description>{i18n("rewards_modal.main_screen.invite_section.description")}</Description>
            <InputContainer data-automation="input-container">
                <ChipsInput
                    emailChips={emailChips}
                    setEmailChips={setEmailChips}
                    inputRef={inputRef}
                    setInvalidEmails={setInvalidEmails}
                    invalidEmails={invalidEmails}
                    isDisabled={isInviteLoading}
                />
                <InviteButton
                    type="primary"
                    width={BUTTON_WIDTH}
                    label={i18n("rewards_modal.main_screen.invite_section.invite_button_text")}
                    onClick={handleInviteClick}
                    isDisabled={hasChipsError}
                    isLoading={isInviteLoading}
                />
                {invitationsList.length > 0 ? (
                    <InvitationsStatusButton
                        type="outlined"
                        width={BUTTON_WIDTH}
                        label={i18n("rewards_modal.main_screen.invite_section.invitation_status_button_text")}
                        onClick={onOpenStatusScreen}
                        isDisabled={isInviteLoading}
                    />
                ) : null}
            </InputContainer>
            {hasChipsError ? (
                <ErrorText>
                    {invalidEmails.length === 1
                        ? i18n("rewards_modal.main_screen.invite_section.one_error_text")
                        : i18n("rewards_modal.main_screen.invite_section.error_text", { number: invalidEmails.length })}
                </ErrorText>
            ) : null}
        </Container>
    );
};

export default InviteSection;
